// extracted by mini-css-extract-plugin
module.exports = {"ScheduleElement":"Schedule_ScheduleElement__36SMb","Label":"Schedule_Label__xqo_Q","Icon":"Schedule_Icon__1M1He"};